/**
 * Hook to access theme colors
 * Returns the current theme's color palette with the active variant applied.
 */

import { useMemo } from 'react';
import { useTheme } from '../theme/useTheme';
import { getTheme } from './themes';
import { applyVariant } from './themes/variant-transform';
import { ColorPalette } from './types';

export const useThemeColors = (): ColorPalette => {
  const { theme, variant } = useTheme();

  // Memoize: re-compute only when theme or variant changes
  return useMemo(
    () => applyVariant(getTheme(theme).palette, variant),
    [theme, variant]
  );
};
